module.exports = __webpack_public_path__ + "media/images/front/icon_new-window-dfea3621cb2e2f486cbdc770488f90da.png";